import {
  apiClient,
  type PageEntity,
  type TourImportJobExEntity
} from '@/libs/api'
import { type TourImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTourImportJobsQuery = {
  tenantKey: string
  query: TourImportJobsRequestQuery
}

export type FetchTourImportJobsResponse = {
  data: TourImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTourImportJobs = async (
  { tenantKey, query }: FetchTourImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTourImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .tour_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
